import UserPreferences from '../../domain/UserPreferences';

const updateHighContrastMode = ({ userPreferencesRepository }) => async enabled =>
  userPreferencesRepository.updateUserPreferences(
    UserPreferences.create({ highContrastMode: enabled })
  );

export default updateHighContrastMode;
